import React from 'react';
import {BrowserRouter, Route, Routes} from 'react-router-dom';
import './App.css';
import Home from "./Component/Home";
import Sitelayout from "./Layout/Sitelayout";
import HomePage from './Component/Home/HomePage';
import Aboutus from "./Component/Aboutus/Aboutus";
import Portfolio from "./Component/Portfolio/Portfolio";
import Cheatsheets from "./Component/Cheatsheets/Cheatsheets";

function App () {
	return (
		<BrowserRouter>
			<Routes>
				<Route element={<Sitelayout/>}>
					<Route path='/' element={<Home/>}/>
					<Route path='/about-us' element={<Aboutus/>}/>
					<Route path="/protfolio" element={<Portfolio />} />
					<Route path="/cheatsheets" element={<Cheatsheets />} />
				</Route>
				<Route path="/homepage" element={<HomePage />} />
			</Routes>
		</BrowserRouter>
	)
		;
}

export default App;